import { Component } from 'vue-property-decorator'
import Vue from '@src/vue'
import Member from '@src/data/member'
import { CreateElement } from 'vue'
import { Button } from '@src/elements/button/button'
import { Subtitle2 } from '@src/elements/typography/typography'
import AssignToMember from '@src/pages/assign-to-member/assign-to-member'
import SessionManager from '@src/lib/session_manager'

@Component({
  computed: {
    member () {
      // @ts-ignore
      const raw = localStorage.getItem('member')
      let memberStorage = null
      if (raw) {
        try { memberStorage = JSON.parse(raw) } catch (_) { localStorage.removeItem('member') }
      }
      return this.$store.state.memberProfile || this.$store.state.selectedMember || memberStorage
    }
  }
})

export class AssignWorkoutToMember extends Vue {

  // member to which the workout will be assigned to
  protected member: Member | null

  private showAssignMember: boolean = false

  private allowMemberChange: boolean

  created () {
    if (this.member) {
      localStorage.setItem('member', JSON.stringify(this.member))
      // if the member data is sent over by the trainings menu, deactivate the member edit
      this.allowMemberChange = false
      return
    }

    if (SessionManager.Instance.isManager()) {
      this.allowMemberChange = true
    }
  }

  // @Watch('member')
  // updateAllowMemberChange () {
  //   this.allowMemberChange = !this.member
  // }

  beforeDestroy () {
    localStorage.removeItem('member')
  }

  render (h: CreateElement) {
    return <div class='assign-to-wrapper'>
      {this.allowMemberChange ?
        <div class={'assign-member-change'}>
          <Button class='assign-to-btn' type={this.member ? 'square-outline-blue' : 'square-outline-red'}
                  label={this.$t('ASSIGN')} click={this.showHideAssignToMember}/>
          {this.member ?
            <Subtitle2 class='member-name'>{this.member!.firstName + ' ' + this.member!.lastName}</Subtitle2> : ''}
        </div> : (this.member ?
        <Subtitle2 class='member-name'>{this.member!.firstName + ' ' + this.member!.lastName}</Subtitle2> : '')}
      {this.showAssignMember ?
        <div class='assign-to-content'>
          {/* close will be triggered by click outside the assign component */}
          <AssignToMember initialSelectedMember={this.member || null} callback={this.persistMemberAssignmentData} hideDate={true} closeCallback={this.showHideAssignToMember} />
        </div>
        : ''}
    </div>
  }

  showHideAssignToMember () {
    this.showAssignMember = !this.showAssignMember
  }

  persistMemberAssignmentData (member: Member) {
    this.$store.dispatch('setMemberForActiveWorkout', member)
    this.$store.dispatch('setSelectedMember', member)

    if (member) this.showHideAssignToMember()
    this.$forceUpdate()
  }
}
